<mat-card>
  <h1>
    ￥{{ data?.frozen_commission | number }}
    <mat-icon>ac_unit</mat-icon>
  </h1>
  <h2>冻结中的佣金</h2>
  <span>冻结佣金在七天后解冻</span>
</mat-card>
